import is from 'is_js';

export function getFeedback(state, sessionId, studentId) {
  const id = `${sessionId}-${studentId}`;
  return state.get('rootReducer').get('feedback').get(id);
}

export function getFeebackItems(state, sessionId, studentId) {
  return getItems(getFeedback(state, sessionId, studentId));
}

export function getItems(feedback) {
  return feedback && Object.getOwnPropertyNames(feedback.toJSON()).map((name) => ({
    name,
    value: feedback[name],
  }));
}

export function hasFeedbackSaved(state, sessionId, studentId) {
  return is.existy(getFeedback(state, sessionId, studentId));
}



// WEBPACK FOOTER //
// ./data/Feedback/accessors.js